import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index'
import Demo from '@/views/demo/demo'
import Service from '@/views/service'
import Product from '@/views/product'
import ResourceManagement from '@/views/product/resource-management'
import NewManagement from '@/views/product/new-management'
import Fuelgas from '@/views/product/fuelgas'
import Spinning from '@/views/product/spinning'
import Atp from '@/views/product/atp'
import Educloud from '@/views/product/educloud'
import Aboutus from '@/views/aboutus'
import Overview from '@/views/aboutus/overview'
import Join from '@/views/aboutus/join'
import History from '@/views/aboutus/history'
import Honor from '@/views/aboutus/honor'
import News from '@/views/aboutus/news'
import NewsDetail from '@/views/aboutus/news/detail'

Vue.use(Router)
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index

    },
    {
      path: '/demo',
      name: 'demo',
      component: Demo
    },
    {
      path: '/service',
      name: 'service',
      component: Service
    },
    {
      path: '/product',
      name: 'product',
      component: Product
    },
    {
      path: '/product/resourceManagement',
      name: 'resourceManagement',
      component: ResourceManagement
    },
    {
      path: '/product/spinning',
      name: 'spinning',
      component: Spinning
    },
    {
      path: '/product/fuelgas',
      name: 'fuelgas',
      component: Fuelgas
    },
    {
      path: '/product/newManagement',
      name: 'newManagement',
      component: NewManagement
    },
    {
      path: '/product/atp',
      name: 'atp',
      component: Atp
    },
    {
      path: '/product/educloud',
      name: 'educloud',
      component: Educloud
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: Aboutus,
      children: [
        {
          path: '/',
          redirect: 'overview'
        }, {
          path: 'overview',
          component: Overview
        }, {
          path: 'join',
          component: Join
        }, {
          path: 'history',
          component: History
        }, {
          path: 'honor',
          component: Honor
        }, {
          path: 'news',
          component: News
        }, {
          path: 'news/detail',
          component: NewsDetail
        }
      ]
    }
  ]
})
router.afterEach((to, from, next) => {
  window, scrollTo(0, 0)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js